<template>
  <div class="sidebar-menu">
    <div class="profile-section">
      <div class="profile-image">
        <img :src="userIcon" class="sidemenu-icon" />
      </div>
      <p class="supervisor-name">
        {{
          capitalizeFirstLetter(getFirstName(user?.nombres)) ||
          "Sin información de usuario"
        }}
        {{ capitalizeFirstLetter(getFirstLastName(user?.apellidos)) || "" }}
      </p>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { useSupStore } from "../stores/supStore.js";
import useUserStore from "../stores/userStore.js";
import usuario from "../assets/images/usuario.svg";

export default {
  name: "SideMenu",
  data() {
    return {
      userIcon: usuario,
    };
  },
  setup() {
    const supStore = useSupStore();
    const selectedSup = computed(() => supStore.selectedSup);
    const userStore = useUserStore();
    const user = userStore.user;

    const getFirstName = (fullName) => {
      return fullName ? fullName.split(" ")[0] : "";
    };

    const getFirstLastName = (lastName) => {
      return lastName ? lastName.split(" ")[0] : "";
    };

    function capitalizeFirstLetter(str) {
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }

    return {
      selectedSup,
      user,
      getFirstName,
      getFirstLastName,
      capitalizeFirstLetter,
    };
  },
};
</script>

<style scoped>
@import "../css/sidemenu.css";
</style>
